module.exports = __webpack_public_path__ + "KP.png?3bd86b3547322b26b5105e2f66736731";